import { Chip } from '@mui/material'
// biome-ignore lint/style/useImportType: <Not a type-only import>
import React from 'react'
import { BadgeType, type PerkBadgeProps } from './types/badge.types'

const badgeConfigs = {
  [BadgeType.TECHSTARS_COMPANY]: {
    backgroundColor: 'rgb(21, 97, 138)',
    textColor: '#fff',
  },
  [BadgeType.GLOBAL_NETWORK_PARTNER]: {
    backgroundColor: 'rgb(71, 131, 75)',
    textColor: '#fff',
  },
  [BadgeType.CATEGORY]: {
    backgroundColor: 'rgb(224, 224, 224)',
    textColor: 'inherit',
  },
}

const PerkBadge: React.FC<PerkBadgeProps> = ({ type, label }) => {
  const config = badgeConfigs[type]

  return (
    <Chip
      key={label}
      label={label}
      size="small"
      sx={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
      }}
    />
  )
}

export default PerkBadge
